import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import { wsGetAll } from 'services/WService';
import LayerCombo from 'components/Tvendo/Common/LayerCombo';
import { Checkbox, FormControlLabel, MenuItem } from '@material-ui/core';
import useLayerContext from 'contexts/layerContext';

//informativas: no cambian ninguna regla, marcan donde hay problemas de cobertura
const SENALES = ['Normal', 'Buena', 'Regular', 'Malo'];

export default function ModalRoute(props) {
  const route = props.model;

  const [dataChanging, setDataChanging] = useState(route);
  const [zones, setZones] = useState([]);
  const { layers } = useLayerContext();
  // Las rutas mayoristas (canal 2) nacen con varios vendedores: si no se toca el check, lo aplica el ws
  const isWholesaleLayer = layers.find((i) => i.id == dataChanging.base_layer_id)?.base_canal_id == 2;

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value,
    });
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    listZones();
  }, []);

  useEffect(() => {
    setDataChanging(route);
  }, [route]);

  return (
    <Modal
      title="Ruta"
      model={route}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="base/route"
      state
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        value={dataChanging?.code || route?.code || ''}
        onInput={(e) => handleChange('code', e.target.value)}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        value={dataChanging?.description || route?.description || ''}
        onInput={(e) => handleChange('description', e.target.value)}
        required
      />
      {zones.length > 0 ? (
        <Autocomplete
          options={zones}
          getOptionLabel={(option) => option.description}
          value={
            !!route ? zones.find((item) => item.id == dataChanging.base_zone_id) || null : null
          }
          renderInput={(params) => <TextField {...params} label="Zona" margin="normal" required />}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_zone_id', item.id);
            }
            handleChange('base_zone_id', null);
          }}
        />
      ) : undefined}
      <LayerCombo
        layers={layers}
        required
        defaultLayer={layers.find((i) => i.id == dataChanging.base_layer_id)}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('base_layer_id', item.id);
          }
          handleChange('base_layer_id', null);
        }}
      />
      <AllowedGuard permission={ConstantPermissions.BASE_ROUTES_FREIGHT_RATE}>
        <TextField
          label="Porcentaje flete"
          fullWidth
          type="number"
          name="freight_rate"
          margin="normal"
          value={dataChanging?.freight_rate || route?.freight_rate || 0}
          onInput={(e) => handleChange('freight_rate', e.target.value)}
          inputProps={{ step: 0.01, min: 0 }}
          required
        />
      </AllowedGuard>

      <TextField
        label="Calidad de señal"
        select
        fullWidth
        margin="normal"
        value={dataChanging?.signal_quality ?? route?.signal_quality ?? 'Normal'}
        onChange={(e) => handleChange('signal_quality', e.target.value)}
      >
        {SENALES.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="Comentario de la señal"
        fullWidth
        margin="normal"
        multiline
        value={dataChanging?.signal_comment ?? route?.signal_comment ?? ''}
        onChange={(e) => handleChange('signal_comment', e.target.value)}
        inputProps={{ maxLength: 500 }}
      />

      <FormControlLabel
        label="Validar gps"
        control={
          <Checkbox
            margin="normal"
            checked={dataChanging.validate_gps === undefined ? true : dataChanging.validate_gps}
            onChange={(e) => {
              handleChange('validate_gps', e.target.checked);
            }}
          />
        }
      />

      <FormControlLabel
        label="Permitir varios vendedores el mismo día"
        control={
          <Checkbox
            margin="normal"
            checked={dataChanging.multiple_sellers === undefined ? isWholesaleLayer : dataChanging.multiple_sellers}
            onChange={(e) => {
              handleChange('multiple_sellers', e.target.checked);
            }}
          />
        }
      />

      <FormControlLabel
        label="Usar el margen de esta ruta al cerrar operación"
        control={
          <Checkbox
            margin="normal"
            checked={
              dataChanging.use_route_max_distance === undefined
                ? false
                : dataChanging.use_route_max_distance
            }
            onChange={(e) => {
              handleChange('use_route_max_distance', e.target.checked);
            }}
          />
        }
      />

      {/* Apagado el interruptor de arriba manda la distancia de digitación de
          pedidos; el campo queda visible igual para poder dejarlo cargado. */}
      <TextField
        label="Margen de la ruta (metros)"
        fullWidth
        type="number"
        margin="normal"
        value={dataChanging?.max_distance ?? route?.max_distance ?? 150}
        onInput={(e) => handleChange('max_distance', e.target.value)}
        inputProps={{ step: 1, min: 0 }}
      />

      <TextField
        label="Distancia para liquidar en delivery"
        helperText="Vacío usa la distancia general para liquidar"
        fullWidth
        type="number"
        margin="normal"
        value={dataChanging?.deliv_distance ?? route?.deliv_distance ?? ''}
        onInput={(e) => handleChange('deliv_distance', e.target.value)}
        inputProps={{ step: 1, min: 0 }}
      />

      <AllowedGuard permission={ConstantPermissions.BASE_ROUTES_LOCKED_UPDATE}>
        <FormControlLabel
          label="Bloquear actualizaciones gps"
          control={
            <Checkbox
              margin="normal"
              checked={dataChanging.locked === undefined ? false : dataChanging.locked}
              onChange={(e) => {
                handleChange('locked', e.target.checked);
              }}
            />
          }
        />
      </AllowedGuard>
    </Modal>
  );
}
